import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { format } from 'date-fns';
import { getPlayerSitecoreData } from 'general/js/helpers';
import { liveHole } from 'components/live-hole';
import { IS_HOLECARD_AVAILABLE } from 'general/js/constants';
import TeeTimesWidgetCard from './tee-times-widget-card';
import { groupStatus } from './enums';


class TeeTimesWidgetGroup extends React.Component {
    constructor(props) {
        super(props);
        this.rootRef = React.createRef();
    }

    componentDidMount() {
        this.setNextOut();
    }

    componentDidUpdate() {
        this.setNextOut();
    }

    setNextOut() {
        const { model, nextOutDate, setNextOut } = this.props;

        if (nextOutDate &&
            nextOutDate === model.startDate &&
            typeof setNextOut === 'function') {
            setNextOut(this.rootRef.current);
        }
    }

    getFeaturedUrl(group) {
        let featuredUrl = null;

        group.players.some((player) => {
            const sitecoreData = getPlayerSitecoreData(this.props.sitecorePlayers, player.id);

            if (sitecoreData && sitecoreData.featuredGroupLiveUrl) {
                featuredUrl = sitecoreData.featuredGroupLiveUrl;
                return true;
            }

            return false;
        });

        return featuredUrl;
    }


    getFeaturedGroupText() {
        const { model } = this.props;
        let text = 'Featured group';

        if (model.status === groupStatus.INACTIVE) {
            text = `Watch from ${format(model.startDate.replace('Z', ''), 'h:mm a')}`;
        }

        return text;
    }

    render() {
        const { model, isEven, isOnHole } = this.props;

        if (!model) return null;

        const stateCss = classNames({
            'is-inactive': model.status === groupStatus.INACTIVE,
            'is-active':
                model.status === groupStatus.ACTIVE ||
                model.status === groupStatus.FINISHED,
            'is-even': isEven || false,
        });
        const listBlock = 'tee-times-widget-group-list';
        const listBemCss = classNames({
            [`${listBlock}--is-less-three`]: model.players.length < 3,
            [`${listBlock}--is-equal-three`]: model.players.length === 3,
            [`${listBlock}--is-equal-four`]: model.players.length === 4,
            [`${listBlock}--is-more-four`]: model.players.length > 4,
            [`${listBlock}--ends-one`]: model.players.length % 3 === 1,
            [`${listBlock}--ends-two`]: model.players.length % 3 === 2,
            [`${listBlock}--ends-three`]: model.players.length % 3 === 0,
        });

        const teeTime = model.startDate && format(model.startDate.replace('Z', ''), 'h:mm a');
        const featuredUrl = this.getFeaturedUrl(model);
        const selectedRoundId = this.props.selectedRoundId;
        const activeRoundId = this.props.activeRoundId;

        return (
            <div className={`tee-times-widget-group ${stateCss}`} ref={this.rootRef}>
                <div className="tee-times-widget-group__header">
                    {
                        isOnHole ?
                            <div className="tee-times-widget-group__on-hole">On hole</div> :
                            <React.Fragment>
                                {
                                    model.status === groupStatus.INACTIVE &&
                                    <div className="tee-times-widget-group__time">
                                        <svg className="icon" width="14" height="14" focusable="false">
                                            <use xlinkHref="#icon-clock"></use>
                                        </svg>
                                        <div className="tee-times-widget-group__time-text">{teeTime}</div>
                                    </div>
                                }
                                {
                                    model.status === groupStatus.ACTIVE && IS_HOLECARD_AVAILABLE &&
                                    <div
                                        className="hole-flag hole-flag--base"
                                        onClick={() => liveHole.show(Number(model.holeId))}
                                        tabIndex="0"
                                        role="button"
                                        aria-label={`Read more about hole ${model.holeId}`}
                                    >{model.holeId}</div>
                                }
                                {
                                    model.status === groupStatus.ACTIVE && !IS_HOLECARD_AVAILABLE &&
                                    <div
                                        className="hole-flag hole-flag--base not-interactive"
                                        tabIndex="0"
                                        role="button"
                                    >{model.holeId}</div>
                                }
                                {
                                    model.status === groupStatus.FINISHED &&
                                    <div className="tee-times-widget-group__finished">Finished round</div>
                                }
                            </React.Fragment>
                    }
                    <div className="tee-times-widget-group__line">
                        {
                            (model.startTee === 10 || model.startTee === '10') &&
                            <div className="tee-times-widget-group__two-tee">10TH tee start</div>
                        }
                        {
                            featuredUrl && (selectedRoundId === activeRoundId) &&
                            <a className="tee-times-widget-group__featured" href={featuredUrl}>
                                <span className="tee-times-widget-group__featured-label">{this.getFeaturedGroupText()}</span>
                                <div className="tee-times-widget-group__featured-icon">
                                    <svg className="icon" width="10" height="10" focusable="false">
                                        <use xlinkHref="#icon-watch"></use>
                                    </svg>
                                </div>
                            </a>
                        }
                        <div className="tee-times-widget-group__title">Game {model.id}</div>
                    </div>
                </div>
                <div className={`tee-times-widget-group-list ${listBemCss}`}>
                    {
                        Array.isArray(model.players) &&
                        model.players.map((player) => {
                            const playerModel = Object.assign({},
                                player,
                                {
                                    sitecoreData: getPlayerSitecoreData(this.props.sitecorePlayers, player.id)
                                });

                            return (<div
                                key={player.id}
                                className={`tee-times-widget-group-list__li ${stateCss}`}
                            >
                                <TeeTimesWidgetCard model={playerModel} status={model.status} />
                            </div>);
                        })
                    }
                </div>
            </div>
        );
    }
}

TeeTimesWidgetGroup.propTypes = {
    model: PropTypes.object,
    nextOutDate: PropTypes.string,
    isEven: PropTypes.bool,
    setNextOut: PropTypes.func,
};

export default TeeTimesWidgetGroup;
